import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {TargetGroupsDetailsComponent} from './target-groups-details.component';

const routes: Routes = [
  {path: 'targetgroups/details', component: TargetGroupsDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class TargetGroupsDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-details/target-groups-details-routing.module.ts